<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N3WrZ3/tc-custom/9781488056284.jpg?1726519377413" alt="This image is the cover for the book Deadly Identity & Deadly Silence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Identity & Deadly Silence
      </h1>
      <p class="bookDescription body article font2">
        <b>Men in uniform juggle fatherhood and love in these two romantic suspense novels set in Wyoming from a <i>New York Times</i>–bestselling author.</b><br/><br/><i>Deadly Identity</i><br/><br/>Once upon a time, a tragic decision dashed Rachel Carson’s plans and made her scared of her own shadow. Now on the run, she vows to help care for a motherless little girl, left in the protection of handsome Sheriff Cade Garner. Cade will do whatever is necessary to protect baby Jenny and give her the life she deserves. But his sharp instincts tell him something is up with the mysterious nanny who swept into their lives.<br/><br/><i>Deadly Silence</i><br/><br/>Lieutenant Matt Sinclaire always loved fighting fires—until the fateful day when the flames took his wife and left him alone with an eight-year-old daughter too traumatized to speak. When U.S. Forest Ranger Casey Cantrell is assigned to Jackson Hole, Wyoming, the last thing she expects to find is a wounded firefighter. But after a chance encounter, she finds herself becoming almost a mother to his little girl. But can Matt protect them all from the evil that stripped him of his life once before?<br/><br/><b>Praise for Lindsay McKenna:</b><br/><br/><b>“McKenna skillfully takes readers on an emotional journey into two people’s hearts.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindsay McKenna
      </h2>
      
      <p class="authorDescription body article">A U.S. Navy veteran, she&#160;pioneered the military romance in 1993 with Captive of Fate, Silhouette Special edition. In 1989, she pioneered the 3-book series coming out monthly with the Love &amp; Glory series.&#160; Her heart is on honoring our military men and women.&#160; Creator of the Wyoming Series and Shadow Warriors series for HQN, she writes emotionally intense love and suspense stories. Visit her online at <a href="http://www.LindsayMcKenna.com">www.LindsayMcKenna.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e36cff86